var Localisation = L.Class.extend({

    options: {
        defaultLanguage: 'en',
        staticElements: [
            'settings.title', 'share.title', 'help.title', 'help.subtitle', 'help.body', 'help.linkMore', 'help.appLinks',
            'help.contactUs', 'help.reportAnIssue', 'reportIssue.title', 'reportIssue.body', 'reportIssue.poorRoute',
            'reportIssue.unsafeRoad', 'reportIssue.unsafeRoadLocation', 'reportIssue.details', 'reportIssue.email',
            'reportIssue.submit'
        ]
    },

    en: {
        'search.roundTrip': 'Round trip',
        'search.pointToPoint': 'Point to Point',
        'search.kmRoute': 'km route',
        'search.mileRoute': 'mile route',
        'search.targetDistanceDirect': 'Direct route',
        'search.targetDistanceCustom': 'Custom',
        'search.startLocationPlaceholderDesktop': 'Start location (click the map)',
        'search.startLocationPlaceholderMobile': 'Start location (long press the map)',
        'search.endLocationPlaceholder': 'End location',
        'search.otherLocationPlaceholder': 'Location',
        'settings.title': 'Settings',
        'settings.preferGreenAreas': 'Prefer green areas:',
        'settings.preferGreenAreasDisabled': 'Disabled',
        'settings.hillsPreference': 'Hills preference:',
        'settings.hillsPreferencePositive': 'Prefer hills',
        'settings.hillsPreferenceNegative': 'Avoid hills',
        'settings.hillsPreferenceNone': 'No preference',
        'settings.avoidRepetition': 'Avoid repetition',
        'settings.avoidUnsafeRoads': 'Avoid potentially unsafe roads',
        'settings.avoidUnlitStreets': 'Avoid unlit streets',
        'settings.mapLayers': 'Map layers:',
        'settings.mapLayerTrailRouter': 'Trail Router default map',
        'settings.mapLayerDarkMap': 'Dark map',
        'settings.mapLayerLightMap': 'Light map',
        'settings.mapLayerSatellite': 'Satellite',
        'settings.showMajorHikingRoutes': 'Show major hiking routes',
        'settings.showStravaHeatmap': 'Show Strava heatmap',
        'settings.showFKTroutes': 'Show Fastest Known Time routes',
        'settings.uiPreferences': 'User interface preferences:',
        'settings.imperial': 'Use miles instead of km',
        'settings.drawStraightLines': 'Draw straight lines',
        'settings.runMode': 'Run mode (lock route, follow GPS)',
        'settings.help': 'Help',
        'share.title': 'Share',
        'share.yourSavedRoutes': 'Your saved routes',
        'share.logout': 'Sign out',
        'share.saveCurrentRoute': 'Save current route',
        'share.loginMessage': 'Sign in to save your favourite routes',
        'share.exportMessage': 'You can export your route as a GPX/KML file for use in watches and offline navigation apps.',
        'share.exportGpx': 'Export GPX',
        'share.exportKml': 'Export KML',
        'share.shareableLinkMessage': 'Click below to generate a link that will allow others to see the route you have created.',
        'share.shareableLink': 'Generate shareable link',
        'share.noSavedRoutes': 'You do not have any saved routes. Click below to create one.',
        'share.deleteConfirm': 'Are you sure you want to delete this route?',
        'error.plotRouteFirst': 'You must plot a route first',
        'help.title': 'Help',
        'help.subtitle': 'Trail Router helps you discover new running routes.',
        'help.body': '<p>Our routing algorithm prefers paths that go through parks, forests or by water, and avoids busy roads wherever possible.</p><p>Here are a few things you can do with Trail Router:</p><ul><li>Automatically plot a round-trip route of a desired distance.</li><li>Manually create your own point-to-point route that prefers nature.</li><li>Choose whether you prefer routes that involve nature, well-lit streets or a lack of hills.</li></ul>',
        'help.linkMore': 'Read more about Trail Router.',
        'help.appLinks': '<strong>New:</strong> Get the <a href="/about/download-android" target="_blank">Android app</a> or <a href="/about/download-ios" target="_blank">iPhone app</a>.',
        'help.contactUs': 'Contact us',
        'help.reportAnIssue': 'Report an issue',
        'reportIssue.title': 'Report an issue',
        'reportIssue.body': 'We are not perfect! Help improve Trail Router by reporting an issue here.',
        'reportIssue.poorRoute': 'The generated route was poor',
        'reportIssue.unsafeRoad': 'A road is unsafe for runners (<a href="about.html#unsafe" target="_blank">See FAQ</a>)',
        'reportIssue.unsafeRoadLocation': 'Location of the unsafe road',
        'reportIssue.unsafeRoadLocationInput': 'Click on the map',
        'reportIssue.details': 'Please provide further details',
        'reportIssue.email': 'Your email address',
        'reportIssue.submit': 'Submit issue report',
        'routeDetail.elevationPlaceholder': 'Plot a route to show elevation chart',
        'routeDetail.pathTypeMajorRoad': 'Major road',
        'routeDetail.pathTypeMinorRoad': 'Minor road',
        'routeDetail.pathTypeResidentialRoad': 'Residential road',
        'routeDetail.pathTypeFootpath': 'Footpath',
        'routeDetail.pathTypeTrack': 'Track',
        'routeDetail.pathTypeSteps': 'Steps',
        'routeDetail.pathTypeFerry': 'Ferry',
        'routeDetail.pathTypeConstruction': 'Construction',
        'routeDetail.pathTypeCycleway': 'Cycleway',
        'routeDetail.pathTypePath': 'Path',
        'routeDetail.pathTypeUnknown': 'Unknown',
        'popup.touchAndHold': 'Touch and hold the map to create a waypoint.',
        'popup.setStartPoint': 'Set start point',
        'popup.addWaypoint': 'Add waypoint',
        'popup.addDirectWaypoint': 'Add direct waypoint',
        'popup.viewFKT': 'View FKT',
        'popup.changeToDirect': 'Change to direct',
        'popup.changeToIndirect': 'Change to indirect',
        'popup.deleteWaypoint': 'Delete waypoint',
        'welcome.title': 'Welcome to Trail Router',
        'welcome.body': '<p>Trail Router helps you discover new running routes. Our routing algorithm prefers paths that go through parks, forests or by water, and avoids busy roads wherever possible.</p><p>To get started, accept the location prompt or click on the map to set a starting point.</p>',
        'welcome.ok': 'Okay',
        'welcome.appLinks': 'You can also download the <a href="/about/download-android" target="_blank">Android app</a> or <a href="/about/download-ios" target="_blank">iPhone app</a> (new for February 2021!).',
        'welcome.appLinksAndroid': '<strong>New for December 2020:</strong> Download the new <a href="/about/download-android" target="_blank">Android app</a>, with better performance, better battery life and new features.',
        'welcome.appLinksIOS': '<strong>New for February 2021:</strong> Download the new <a href="/about/download-ios" target="_blank">iPhone app</a>, with better performance, better battery life and new features.',
        'edit.body': 'Changing the settings below will calculate a new set of routes. To edit the current route instead, click below.',
        'edit.editRoute': 'Edit current route',
    },

    de: {
        'search.roundTrip': 'Rundweg',
        'search.pointToPoint': 'Einwegstrecke',
        'search.kmRoute': 'km Strecke',
        'search.mileRoute': 'Meilen Strecke',
        'search.targetDistanceDirect': 'Einwegstrecke',
        'search.targetDistanceCustom': 'Andere Länge',
        'search.startLocationPlaceholderDesktop': 'Startpunkt (auf der Karte anklicken)',
        'search.startLocationPlaceholderMobile': 'Startpunkt (auf der Karte lange drücken)',
        'search.endLocationPlaceholder': 'Endpunkt',
        'search.otherLocationPlaceholder': 'Ort',
        'settings.title': 'Einstellungen',
        'settings.preferGreenAreas': 'Grüne Landschaft bevorzugen:',
        'settings.preferGreenAreasDisabled': 'Ausgeschaltet',
        'settings.hillsPreference': 'Hügeleinstellung:',
        'settings.hillsPreferencePositive': 'Hügel bevorzugen',
        'settings.hillsPreferenceNegative': 'Hügel vermeiden',
        'settings.hillsPreferenceNone': 'Egal',
        'settings.avoidRepetition': 'Vermeide Wiederholung',
        'settings.avoidUnsafeRoads': 'Vermeide potenziell unsichere Straßen',
        'settings.avoidUnlitStreets': 'Vermeide unbeleuchtete Straßen',
        'settings.mapLayers': 'Kartenebenen:',
        'settings.mapLayerTrailRouter': 'Trail Router Standardkarte',
        'settings.mapLayerDarkMap': 'Dunkle Karte',
        'settings.mapLayerLightMap': 'Helle Karte',
        'settings.mapLayerSatellite': 'Satellit',
        'settings.showMajorHikingRoutes': 'Zeige wichtige Wanderwege',
        'settings.showStravaHeatmap': 'Zeige Strava Heatmap',
        'settings.showFKTroutes': 'Zeige Routen von Fastest Known Time',
        'settings.uiPreferences': 'Bedienoberfläche Einstellungen:',
        'settings.imperial': 'Benutze Meilen statt km',
        'settings.drawStraightLines': 'Zeichne gerade Linien',
        'settings.runMode': 'Laufmodus (Route beibehalten, GPS folgen)',
        'settings.help': 'Hilfe',
        'share.title': 'Teilen',
        'share.yourSavedRoutes': 'Deine gespeicherten Routen',
        'share.logout': 'Abmelden',
        'share.saveCurrentRoute': 'Aktuelle Route speichern',
        'share.loginMessage': 'Anmelden, um Routen zu speichern',
        'share.exportMessage': 'Du kannst deine Routen als GPX/KML-Datei speichern und in Smartwatches und offline Navi-Apps nutzen.',
        'share.exportGpx': 'Exportiere GPX',
        'share.exportKml': 'Exportiere KML',
        'share.shareableLinkMessage': 'Klicke unten, um einen Link zu erzeugen, mit dem andere deine Route sehen können.',
        'share.shareableLink': 'Link zum Weitergeben erzeugen',
        'share.noSavedRoutes': 'Sie haben keine gespeicherten Strecken. Klicken Sie unten, um eine zu erstellen.',
        'share.deleteConfirm': 'Möchten Sie diese Strecke wirklich löschen?',
        'error.plotRouteFirst': 'Sie müssen zuerst eine Strecke erstellen',
        'help.title': 'Hilfe',
        'help.subtitle': 'Mit Trail Router entdeckst du neue Laufstrecken.',
        'help.body': '<p>Unser Routing-Algorithmus bevorzugt Wege, die durch Parks, Wälder oder an Gewässern entlang führen und vermeidet nach Möglichkeit stark befahrene Straßen.</p><p>Beispiele, was du mit Trail Router tun kannst:</p><ul><li>Automatisch einen Rundweg mit der gewünschten Länge planen.</li><li>Manuell deine eigene Einwegstrecke durch vorzugsweise Natur erzeugen.</li><li>Auswählen, ob du Routen bevorzugst, die durch die Natur gehen, durch gut beleuchtete Straßen oder die Hügel vermeiden.</li></ul>',
        'help.linkMore': 'Lies mehr über Trail Router.',
        'help.appLinks': '<strong>Neu:</strong> Hol dir die App für <a href="/about/download-android" target="_blank">Android</a> oder <a href="/about/download-ios" target="_blank">iPhone</a>.',
        'help.contactUs': 'Kontakt',
        'help.reportAnIssue': 'Problem melden',
        'reportIssue.title': 'Problem melden',
        'reportIssue.body': 'Wir sind nicht perfekt! Hilf uns, Trail Router zu verbessern, indem du hier ein Problem meldest.',
        'reportIssue.poorRoute': 'Die erzeugte Route war schlecht.',
        'reportIssue.unsafeRoad': 'Eine Straße ist unsicher für Läufer (<a href="about.html#unsafe" target="_blank">Siehe FAQ</a>)',
        'reportIssue.unsafeRoadLocation': 'Lage der unsicheren Straße',
        'reportIssue.unsafeRoadLocationInput': 'Klicke auf die Karte',
        'reportIssue.details': 'Bitte füge weitere Details hinzu',
        'reportIssue.email': 'Deine E-Mail-Adresse',
        'reportIssue.submit': 'Problembericht abschicken',
        'routeDetail.elevationPlaceholder': 'Plane eine Route, um ein Höhenprofil zu zeigen',
        'routeDetail.pathTypeMajorRoad': 'Hauptstraße',
        'routeDetail.pathTypeMinorRoad': 'Nebenstraße',
        'routeDetail.pathTypeResidentialRoad': 'Wohnstraße',
        'routeDetail.pathTypeFootpath': 'Fußweg',
        'routeDetail.pathTypeTrack': 'Weg',
        'routeDetail.pathTypeSteps': 'Schritte',
        'routeDetail.pathTypeFerry': 'Fähre',
        'routeDetail.pathTypeConstruction': 'Baustelle',
        'routeDetail.pathTypeCycleway': 'Fahrradweg',
        'routeDetail.pathTypePath': 'Pfad',
        'routeDetail.pathTypeUnknown': 'Unbekannt',
        'popup.touchAndHold': 'Berühren und halten Sie die Karte, um einen Wegpunkt zu erzeugen.',
        'popup.setStartPoint': 'Anfangspunkt setzen',
        'popup.addWaypoint': 'Wegpunkt hinzufügen',
        'popup.addDirectWaypoint': 'Direkten Wegpunkt hinzufügen',
        'popup.viewFKT': 'FKT anzeigen',
        'popup.changeToDirect': 'Wechseln Sie zu direkt',
        'popup.changeToIndirect': 'Wechseln Sie zu indirekt',
        'popup.deleteWaypoint': 'Wegpunkt löschen',
        'welcome.title': 'Willkommen bei Trail Router',
        'welcome.body': '<p>Mit Trail Router können Sie neue Laufrouten entdecken. Unser Routing-Algorithmus bevorzugt Wege, die durch Parks oder Wälder oder an Gewässern entlang führen, und vermeidet nach Möglichkeit stark befahrene Straßen.</p><p>Akzeptieren Sie zunächst die Standortabfrage oder klicken Sie auf die Karte, um einen Startpunkt festzulegen.</p>',
        'welcome.ok': 'Verstanden',
        'welcome.appLinks': 'Sie können auch die <a href="/about/download-android" target="_blank">Android-App</a> oder die <a href="/about/download-ios" target="_blank">iPhone-App</a> herunterladen (neu für Februar 2021!).',
        'welcome.appLinksAndroid': '<strong>Neu für Dezember 2020:</ strong> Laden Sie die neue <a href="/about/download-android" target="_blank">Android-App</a> mit besserer Leistung, längerer Akkulaufzeit und neuen Funktionen herunter.',
        'welcome.appLinksIOS': '<strong>Neu für Februar 2021:</ strong> Laden Sie die neue <a href="/about/download-ios" target="_blank">iPhone-App</a> mit besserer Leistung, längerer Akkulaufzeit und neuen Funktionen herunter.',
        'edit.body': 'Durch Ändern der folgenden Einstellungen wird ein neuer Satz von Routen berechnet. Klicken Sie unten, um stattdessen die aktuelle Route zu bearbeiten.',
        'edit.editRoute': 'Aktuelle Route bearbeiten',
    },

    initialize: function() {
        var lang = (navigator.language && navigator.language.substring(0,2)) || this.options.defaultLanguage;
        if (this[lang] !== undefined) {
            this.options.language = lang;
        } else {
            this.options.language = this.options.defaultLanguage;
        }
    },

    applyStatic: function() {
        for(var i=0; i<this.options.staticElements.length; i++) {
            var id = this.options.staticElements[i];
            try {
               L.DomUtil.get(id).innerHTML = this.get(id);
            } catch (e) {
               console.log("Error applying localisation for "+id+": "+e.message);
            }
        }
    },

    // A method 
    get: function(key) {
        return this[this.options.language][key];
    }
    
});

L.localisation = new Localisation();

